import aguero from "../assets/media/img/staff/Aguero.png"
import alet from "../assets/media/img/staff/Alet.jpg"
import dadic from "../assets/media/img/staff/Dadic.png"
import devicentiis from "../assets/media/img/staff/DeVicentiis.png"
import lauretta from "../assets/media/img/staff/Lauretta.jpg"
import lingua from "../assets/media/img/staff/Lingua.jpg"
import montessi from "../assets/media/img/staff/Montessi.png"
import nicolau from "../assets/media/img/staff/Nicolau.JPG"
import pastor from "../assets/media/img/staff/Pastor.png"
import pingitore from "../assets/media/img/staff/Pingitore.png"
import slipakhijo from "../assets/media/img/staff/SlipakHijo.jpeg"
import zareba from "../assets/media/img/staff/Zareba.jpg"
import pedernera from "../assets/media/img/staff/Pedernera.jpg"
import iermoli from "../assets/media/img/staff/Iermoli.jpg"
import henderson from "../assets/media/img/staff/Henderson.jpg"
import enei from "../assets/media/img/staff/Enei.jpg"
import lallo from "../assets/media/img/staff/Lallo.JPG"
import farinelli from "../assets/media/img/staff/Farinelli.png"
import maffia from "../assets/media/img/staff/maffia.JPG"
import acosta from "../assets/media/img/staff/Acosta.jpeg"
import carchini from "../assets/media/img/staff/carchini.jpg"
import manfredi from "../assets/media/img/staff/Manfredi.png"

import adicciones from "../assets/media/img/cursos/addicciones.webp"
import nutriClinica from "../assets/media/img/cursos/posgrado-nutricion.jpg"
import innovacion from "../assets/media/img/cursos/innovacion.jpg"
import ia from "../assets/media/img/cursos/inteligencia-artificial.png"
import bioFacial from "../assets/media/img/cursos/remodelacion-facial.jpg"
import nutriMicrobiota from "../assets/media/img/cursos/nutricion-microbiota.jpg"
import toxicologia from "../assets/media/img/cursos/toxicologia.jpg"
import nutriDeportiva from "../assets/media/img/cursos/nutricion-deportiva.jpg"
import plantbased from "../assets/media/img/cursos/plantbased.jpg"
import skincare from "../assets/media/img/cursos/skincare.png"
import rcp from "../assets/media/img/cursos/rcp.jpg"
import prehospitalario from "../assets/media/img/cursos/prehospitalario-emergencias.jpg"
import diabetes from "../assets/media/img/cursos/nutricion-y-diabetes.png"
import inmunizaciones from "../assets/media/img/cursos/temp-programa-inmunizaciones.jpg"
import neurocardio from "../assets/media/img/cursos/urgencias-neurocardiologicas.png"
import dermatologia from "../assets/media/img/cursos/dermatologia-estetica-terapeutica.jpg"
import acompAdicciones from "../assets/media/img/cursos/acomp-addiciones.jpg"
import bigData from "../assets/media/img/cursos/big-data.jpg"
import capilar from "../assets/media/img/cursos/transplante-capilar.jpg"
import forense from "../assets/media/img/cursos/forenses.jpg"
import ginecologia from "../assets/media/img/cursos/gineco.webp"
import marketing from "../assets/media/img/cursos/marketing.png"
import oncologica from "../assets/media/img/cursos/enfermeria-oncologica.jpg"
import consumos from "../assets/media/img/cursos/consumos-problematicos.png"
import gestionEnfermeria from "../assets/media/img/cursos/gestion-administracion-enfermeria.jpg"
import medicinaLaboral from "../assets/media/img/cursos/medicina-laboral.jpeg"

const cursos = [
    {
        id: 344,
        codigoT: "400.32",
        nombre: "Curso de Acompañante Terapéutico Especializado en Adicciones",
        foto: acompAdicciones,
        url: "curso-acomp-terapeutico-adicciones",
        tipo: "Curso",
        categoria: ["salud-mental-y-adicciones", "psiquiatria"],
        area: "Adicciones",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El consumo problemático de sustancias es una problemática en aumento a nivel mundial que impacta en la salud física y mental de los pacientes, y afecta profundamente la autoestima, la identidad y el sentido de vida. La recuperación no solo implica la desintoxicación, sino también la reconstrucción emocional y espiritual del paciente.",
        descripcionExtra: ["Este curso fortalece el rol del Acompañante Terapéutico en la intervención con pacientes con consumo problemático, priorizando la construcción del vínculo terapéutico, el manejo de crisis y la reinserción social. Con un enfoque interdisciplinario, permite que los AT trabajen en conjunto con equipos de salud mental y adicciones."],
        descripcionPreview: "Formación interdisciplinaria para el abordaje del consumo problemático: intervención en crisis, vínculo terapéutico, reducción de daños,...",
        sobreTitulo: "El rol del AT en el abordaje integral del consumo problemático",
        objetivos: ["Formar en la identificación y abordaje del consumo problemático de sustancias desde una perspectiva interdisciplinaria.", "Desarrollar estrategias de intervención y contención en la atención de personas con consumo problemático.", "Introducir conceptos básicos de toxicología y farmacología adaptados al rol del Acompañante Terapéutico.", "Promover herramientas motivacionales, psicoeducativas y el autocuidado para prevenir el desgaste profesional."],
        sistemaEvaluacion: ["Actividades del campus", "Bibliografía", "Examen final"],
        destinatarioTags: ["Acompañantes Terapéuticos", "Público general", "Familiares y cuidadores", "Trabajadores comunitarios", "Profesionales de salud mental"],
        director: ["Dr. Francisco Dadic"],
        directorDetalle: ["Director académico del curso"],
        direccionAcademica: [
            { nombre: "Dr. Francisco Dadic", detalle: "Director académico del curso" }
        ],
        codireccion: ["Lic. Esp. Leonardo De Vincentiis"],
        codireccionDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        codireccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        equipoDocente: [
            { titulo: "Lic. Esp.", nombre: "Alexis Ramallo" },
            { titulo: "Mag.", nombre: "Cynthia De Armas" }
        ],
        directorImg: [dadic],
        codireccionImg: [devicentiis],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: 8,
        horas: null,
        duracion: null,
        unidades: 4,
        destinatarios: "Dirigido al público general. No se requiere título universitario previo. Ideal para acompañantes terapéuticos, familiares, cuidadores y cualquier persona interesada en el abordaje del consumo problemático desde un rol de acompañamiento y contención.",
        requisitos: [null],
        modalidad: "Virtual asincrónico",
        temario: null,
        precioMP: 120000,
        precioSuscripcionMP: 0,
        precioTransferencia: 96000,
        precioPayPal: 500,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 400,
        cuotas: 1,
        linkSuscripcionMP: "",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 309,
        codigoT: "400.28",
        nombre: "Curso Especialista en Skincare",
        foto: skincare,
        url: "diplomatura-skincare",
        tipo: "Curso",
        categoria: ["dermatologia"],
        area: "Skincare · Dermatología",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este curso brinda los conocimientos teóricos necesarios para comprender los fundamentos científicos del cuidado de la piel y desarrollar habilidades específicas en el diseño y aplicación de rutinas de cuidado facial y corporal.",
        descripcionExtra: ["Los participantes aprenderán a evaluar las necesidades individuales de la piel, recomendar productos y tratamientos adecuados, y desarrollar planes personalizados para diversos tipos de piel y condiciones específicas. Incluye cosmética natural, prevención y tratamiento de problemas cutáneos comunes y las últimas tendencias en el campo del skincare."],
        descripcionPreview: "Fundamentos científicos del cuidado de la piel, rutinas personalizadas, ingredientes clave, tratamientos avanzados y skincare ético. Cursá a tu...",
        sobreTitulo: "El skincare como ciencia y práctica personalizada",
        objetivos: ["Comprender los fundamentos científicos del cuidado de la piel: anatomía, fisiología y tipos cutáneos.", "Diseñar rutinas de skincare personalizadas según tipo de piel, condición y necesidades individuales del paciente.", "Conocer los ingredientes clave, sus funciones y su correcta combinación para resultados óptimos.", "Incorporar una visión ética y sostenible del skincare, integrando cosmética natural y prácticas responsables."],
        sistemaEvaluacion: ["Actividades en foro", "Examen final"],
        destinatarioTags: ["Cosmetólogas", "Cosmiatras", "Esteticistas", "Interesados en tratamientos faciales", "Interesados en tratamientos corporales"],
        director: ["Dra. Aldana Lallo"],
        directorDetalle: ["Directora · (MP 120.184) · Esp. en Dermatología"],
        direccionAcademica: [
            { nombre: "Dra. Aldana Lallo", detalle: "Directora · (MP 120.184) · Esp. en Dermatología" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [lallo],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 9,
        destinatarios: "Dirigido a cosmetólogas, cosmiatras, esteticistas y todas aquellas personas que busquen especializarse en tratamientos faciales y corporales. No se requiere título universitario previo.",
        requisitos: [
            "Título Secundario"
        ],
        modalidad: "Virtual asincrónico",
        temario: 28,
        precioMP: 380000,
        precioSuscripcionMP: 127000,
        precioTransferencia: 304000,
        precioPayPal: 525,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 420,
        cuotas: 3,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=20a077993aa94a8a9948d27a6ffa9455",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 112,
        codigoT: "400.5",
        nombre: "Curso Superior en Plant Based",
        foto: plantbased,
        url: "diplomatura-nutricion-plant-based",
        tipo: "Curso",
        categoria: ["nutricion"],
        area: "Nutrición Plant Based",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Las plantas son ricas fuentes de nutrientes que nuestro cuerpo necesita y pueden ayudar a prevenir enfermedades crónicas. La nutrición tiene un papel fundamental en el estado de la salud, sobre todo cuando el paciente padece algún tipo de patología.",
        descripcionExtra: ["Este curso brinda a cada profesional todo el conocimiento actualizado y necesario sobre la alimentación basada en plantas (ABP), permitiendo abordar cada paciente de una forma integral y personalizada, fomentando el desarrollo de un correcto ambiente intestinal y metabolismo."],
        descripcionPreview: "Alimentación basada en plantas: desde sus generalidades y grupos de alimentos hasta nutrientes críticos, microbiota, enfermedades crónicas, ciclo...",
        sobreTitulo: "Alimentación basada en plantas: ciencia, práctica y prevención",
        objetivos: ["Brindar los conocimientos científicos actualizados sobre la alimentación basada en plantas y su impacto en la salud.", "Establecer programas de tratamiento que incluyan a todo el equipo de salud, con educación terapéutica y estrategias de adherencia.", "Identificar nutrientes críticos en la ABP, signos de carencias, factores inhibidores y facilitadores, y uso de suplementos.", "Aportar herramientas para favorecer los cambios necesarios en el estilo de vida del paciente para lograr un óptimo resultado."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Licenciadas/os en Nutrición", "Estudiantes último año (Medicina o Nutrición)", "Graduados UBA", "Otras universidades argentinas", "Universidades extranjeras"],
        director: ["Lic. Laura Iermoli"],
        directorDetalle: ["Directora · (MN 9335) · Lic. en Nutrición"],
        direccionAcademica: [
            { nombre: "Lic. Laura Iermoli", detalle: "Directora · (MN 9335) · Lic. en Nutrición" }
        ],
        codireccion: ["Dra. Elena Pastor Manfredi"],
        codireccionDetalle: ["Co-Directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Co-Directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor" },
            { titulo: "Dr.", nombre: "Roberto H. Iermoli" }
        ],
        directorImg: [iermoli],
        codireccionImg: [manfredi],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 7,
        destinatarios: "Dirigido a médicos, licenciados/as en nutrición y estudiantes del último año de Medicina o Nutrición. Graduados de la UBA, otras universidades argentinas o universidades extranjeras.",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina o Nutrición.",
            "d) Ser estudiante regular del último año de la carrera de Medicina o Nutrición."
        ],
        modalidad: "Virtual asincrónico",
        temario: 5,
        precioMP: 350000,
        precioSuscripcionMP: 58333,
        precioTransferencia: 280000,
        precioPayPal: 390,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 312,
        cuotas: 6,
        linkSuscripcionMP: "",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 341,
        codigoT: "400.29",
        nombre: "Curso de Operador Prehospitalario de Emergencias",
        foto: prehospitalario,
        url: "curso-operador-prehospitalario-emergencias",
        tipo: "Curso",
        categoria: ["emergencias"],
        area: "Emergencias",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este curso proporciona una formación profesional integral, profundizando el conocimiento semiológico y la toma de decisiones en el campo de la atención prehospitalaria. Los participantes aprenderán a conocer la legislación vigente, evaluar ordenadamente la semiología del paciente y estimular el pensamiento crítico ante situaciones de emergencia.",
        descripcionExtra: ["Con 24 unidades que abarcan desde principios generales hasta eventos con víctimas múltiples, el programa forma operadores capaces de responder eficazmente ante cualquier emergencia médica, trauma o situación crítica en el ámbito prehospitalario."],
        descripcionPreview: "Formación profesional en atención prehospitalaria: semiología, toma de decisiones, sistemas corporales, emergencias médicas, trauma, pediatría y...",
        sobreTitulo: "Formación especializada en emergencias prehospitalarias",
        objetivos: ["Proporcionar formación profesional, profundizando el conocimiento semiológico y la toma de decisiones en atención prehospitalaria.", "Conocer la legislación vigente aplicable a las emergencias prehospitalarias y los aspectos médico-legales y éticos del rol.", "Evaluar ordenadamente la semiología del paciente mediante evaluación primaria y secundaria sistemática.", "Estimular el pensamiento crítico y la toma de decisiones ante situaciones de emergencia complejas y eventos con víctimas múltiples."],
        sistemaEvaluacion: ["Teórico", "Examen Parcial", "Examen Final"],
        destinatarioTags: ["Personal Bombero", "Defensa Civil", "Rescatadores", "Enfermeros", "Interesados en emergencias"],
        director: ["Dr. Luis Jorge Montessi", "Dr. Alejandro Nicolau"],
        directorDetalle: ["(M.N. 62268) · Médico Emergentólogo · SAME CABA", "(MN. 158146) · Médico Emergentólogo · SAME CABA"],
        direccionAcademica: [
            { nombre: "Dr. Luis Jorge Montessi", detalle: "(M.N. 62268) · Médico Emergentólogo · SAME CABA" },
            { nombre: "Dr. Alejandro Nicolau", detalle: "(MN. 158146) · Médico Emergentólogo · SAME CABA" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [montessi, nicolau],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 24,
        destinatarios: "Dirigido a personas relacionadas con la atención de emergencias prehospitalarias y a toda aquella persona interesada en el mundo de las emergencias.",
        requisitos: [
            "Título secundario"
        ],
        modalidad: "Virtual asincrónico",
        temario: 29,
        precioMP: 260000,
        precioSuscripcionMP: 130000,
        precioTransferencia: 208000,
        precioPayPal: 120,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 96,
        cuotas: 2,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=5ff9859844304de2ae3878f898b69321",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 342,
        codigoT: "400.30",
        nombre: "Programa Ampliado de Inmunizaciones",
        foto: inmunizaciones,
        url: "programa-inmunizaciones",
        tipo: "Curso",
        categoria: ["enfermeria"],
        area: "Enfermería · Vacunación",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El Programa Ampliado de Inmunizaciones (PAI) es una de las estrategias de salud pública con mayor impacto en la reducción de enfermedades prevenibles. Este curso brinda la información y capacitación necesarias para adquirir competencia en el manejo de vacunas, las técnicas de aplicación y el conocimiento actualizado de los esquemas vigentes.",
        descripcionExtra: ["Una capacitación clave para enfermeros y farmacéuticos que buscan profundizar en el área de mayor salida laboral y mejor remuneración dentro del campo de la enfermería."],
        descripcionPreview: "Capacitación en manejo de vacunas: conceptos del PAI, técnicas de administración, enfermedades del programa, esquemas de vacunación, cadena de...",
        sobreTitulo: "Competencia profesional en el manejo de vacunas",
        objetivos: ["Proporcionar información y capacitación para adquirir competencia en el manejo de vacunas del programa nacional.", "Adquirir conocimientos sobre la inmunización por vacunas y las técnicas de aplicación en sus diferentes vías.", "Conocer los principios de conservación, cadena de frío y gestión de vacunas en organizaciones de salud.", "Capacitarse en el área de enfermería con mayor salida laboral y mejor remuneración del sector."],
        sistemaEvaluacion: ["Teórico", "Examen Parcial", "Examen Final"],
        destinatarioTags: ["Enfermeros/as", "Licenciados/as en Enfermería", "Farmacéuticos", "Estudiantes 3er año Enfermería"],
        director: ["Dr. Abel Luis Agüero"],
        directorDetalle: ["Director del Instituto de Historia de la Medicina · Facultad de Medicina · Magíster en Salud Pública"],
        direccionAcademica: [
            { nombre: "Dr. Abel Luis Agüero", detalle: "Director del Instituto de Historia de la Medicina · Facultad de Medicina · Magíster en Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [aguero],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: null,
        unidades: 6,
        destinatarios: "Dirigido a enfermeros/as, Licenciados/as en Enfermería, farmacéuticos y estudiantes del 3er año de Enfermería que buscan especializarse en vacunación e inmunización.",
        requisitos: [
            "Poseer título de Lic. en Enfermería, Farmacéutico o ser estudiante del tercer año de Enfermería."
        ],
        modalidad: "Virtual asincrónico",
        temario: 30,
        precioMP: 96000,
        precioSuscripcionMP: 0,
        precioTransferencia: 76800,
        precioPayPal: 45,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 36,
        cuotas: 1,
        linkSuscripcionMP: "",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 343,
        codigoT: "400.31",
        nombre: "Curso de RCP + DEA",
        foto: rcp,
        url: "curso-rcp",
        tipo: "Curso",
        categoria: ["emergencias"],
        area: "Emergencias · RCP",
        titulacion: "Título FISP",
        certificaciones: [
            { certificacion: "FISP", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Saber cómo actuar ante un paro cardiorrespiratorio puede marcar la diferencia entre la vida y la muerte. Este curso brinda los conocimientos y técnicas necesarios para responder con eficacia ante una emergencia cardiovascular, incluyendo el uso correcto del Desfibrilador Externo Automático (DEA) en ambientes cardioprotegidos.",
        descripcionExtra: ["Con un enfoque práctico y accesible, está pensado tanto para profesionales de la salud y servicios de emergencia como para cualquier persona que quiera estar preparada para actuar en situaciones de riesgo de vida."],
        descripcionPreview: "Aprendé las técnicas de RCP y el uso del DEA para actuar en situaciones de riesgo de vida. Reconocimiento de la patología, manejo de la escena,...",
        sobreTitulo: "RCP y DEA: herramientas para salvar vidas",
        objetivos: ["Brindar conocimientos y técnicas necesarias para responder ante un paro cardiorrespiratorio.", "Capacitar en el uso correcto del Desfibrilador Externo Automático (DEA) en ambientes cardioprotegidos.", "Preparar a profesionales y público general para actuar con eficacia en situaciones de riesgo de vida."],
        sistemaEvaluacion: ["Examen Final"],
        destinatarioTags: ["Operadores Prehospitalarios", "Personal de Salud", "Bomberos", "Policías", "Rescatistas", "Guardavidas", "Entrenadores", "Público general"],
        director: ["Dr. Luis Jorge Montessi", "Dr. Alejandro Nicolau"],
        directorDetalle: ["(M.N. 62268) · Médico Emergentólogo", "Cuerpo Docente"],
        direccionAcademica: [
            { nombre: "Dr. Luis Jorge Montessi", detalle: "(M.N. 62268) · Médico Emergentólogo" },
            { nombre: "Dr. Alejandro Nicolau", detalle: "Cuerpo Docente" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [],
        directorImg: [montessi, nicolau],
        inicio: null,
        fin: null,
        diasHorarios: null,
        quincenal: false,
        clases: null,
        horas: null,
        duracion: null,
        unidades: 5,
        destinatarios: "Dirigido a todo aquel que quiera estar preparado para actuar ante una emergencia cardiovascular. No se requiere experiencia previa ni título profesional.",
        requisitos: [null],
        modalidad: "Virtual asincrónico",
        temario: 31,
        descuentos: false,
        precioMP: 30000,
        precioSuscripcionMP: 0,
        precioTransferencia: 24000,
        precioPayPal: 0,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 0,
        cuotas: 1,
        linkSuscripcionMP: "",
        linkSuscripcionDlocal: null,
        cuposLlenos: false,
    },
    {
        id: 132,
        codigoT: "400.14",
        nombre: "Diplomatura en Innovación Digital de Salud",
        foto: innovacion,
        url: "diplomatura-innovacion-digital",
        tipo: "Diplomatura",
        categoria: ["tecnologia", "medicina-de-precision"],
        area: "Salud Digital",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "El mundo está cambiando, y el sistema de salud no es ajeno a esos cambios. Vivimos en una sociedad que ha adoptado —de formas diversas— las tecnologías de la información y la comunicación. Es momento de que el sistema de salud también lo haga. No se trata de perder los principios esenciales que lo sostienen, sino de potenciarlos.",
        descripcionExtra: ["Un sistema que no incorpora nuevas tecnologías, que no dialoga con la realidad digital que ya vive la sociedad, será incapaz de materializar principios como no dañar, elevar la calidad de atención y aumentar el acceso. Los sistemas de salud son reflejo de las sociedades que los construyen: si la sociedad cambia, el sistema debe adecuarse."],
        descripcionPreview: "Desde la transformación digital del sistema de salud hasta IA, telesalud, historia clínica electrónica e identidad digital profesional. Titulación...",
        sobreTitulo: "La transformación digital como oportunidad para la salud",
        objetivos: ["Comprender, promover y liderar procesos de innovación en los sistemas de salud, incorporando tecnologías digitales de manera ética y segura.", "Fortalecer la calidad, equidad, eficiencia y sostenibilidad del cuidado de la salud en un entorno de transformación digital continua.", "Impulsar la equidad, prevenir, cuidar y sanar sin encarecer el sistema, centrando la atención en las personas.", "Adquirir herramientas prácticas para diseñar y ejecutar proyectos de mejora e implementación tecnológica en salud."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Estudiantes último año (otras)"],
        director: ["Dr. Federico Pedernera"],
        directorDetalle: ["Director · (M.N. 108146) · Médico y MBA"],
        direccionAcademica: [
            { nombre: "Dr. Federico Pedernera", detalle: "Director · (M.N. 108146) · Médico y MBA" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Marisa Aizenberg" },
            { titulo: "Dra.", nombre: "Analía Baum" },
            { titulo: "Dr.", nombre: "Diego Pereyra" },
            { titulo: "Dr.", nombre: "Alfonso Fernández Pazos" },
            { titulo: "Dr.", nombre: "Alejandro Mauro" },
            { titulo: "Lic.", nombre: "Carolina Casullo" },
            { titulo: "Dr.", nombre: "Sergio Montenegro" },
            { titulo: "Dr.", nombre: "Fernando Plazzotta" },
            { titulo: "Lic.", nombre: "Paula Moriñigo" },
            { titulo: "Dr.", nombre: "Martín Uranga Vega" }
        ],
        directorImg: [pedernera],
        inicio: "05/08/2026",
        fin: "02/12/2026",
        diasHorarios: "Miércoles 18 a 20 hs",
        quincenal: false,
        clases: 17,
        horas: 170,
        duracion: 5,
        unidades: 12,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud.",
            "c) Ser graduado de universidades argentinas con título de otras carreras profesionales.",
            "d) Ser graduado de universidades extranjeras de otras carreras profesionales."
        ],
        modalidad: "Virtual",
        temario: 14,
        precioMP: 1200000,
        precioSuscripcionMP: 200000,
        precioTransferencia: 960000,
        precioPayPal: 800,
        precioSuscripcionPayPal: 135,
        precioTransferenciaUSA: 640,
        precioRegularPayPalEspana: 800,
        precioUnPagoPayPalEspana: 640,
        precioSuscripcionPayPalEspana: 135,
        linkPayPalEspana: "https://www.paypal.com/ncp/payment/2S5W99RLPHCXY",
        linkSuscripcionPayPalEspana: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-55T00797BB8622310ND5HREI",
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=fc64bab326744726985df2de4ab7136f",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/ZWkaetWXbpZJFjUmPpMdhZgnyiEEckkb",
        cuposLlenos: false,
    },
    {
        id: 103,
        codigoT: "400.3",
        nombre: "Diplomatura en Medicina de las Adicciones",
        foto: adicciones,
        url: "diplomatura-medicina-adicciones",
        tipo: "Diplomatura",
        categoria: ["salud-mental-y-adicciones", "psiquiatria"],
        area: "Adicciones",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Las adicciones conllevan un patrón de funcionamiento desadaptativo de consumo que provoca malestar o deterioro significativo. Cuando se habla de drogas, se hace referencia a toda aquella sustancia que, una vez consumida, modifica las funciones del organismo a nivel físico o mental.",
        descripcionExtra: ["Esta diplomatura brinda un análisis exhaustivo abordando la conceptualización de las drogas, la psicobiología de las adicciones y los daños producidos por el consumo. Se profundiza en sustancias específicas —alcohol, tabaco, estimulantes, cannabis, alucinógenos, inhalantes, opiáceos, sedantes y ansiolíticos— y se exploran la adicción tecnológica y el juego patológico, con herramientas concretas para la prevención y el tratamiento."],
        descripcionPreview: "Análisis exhaustivo de las adicciones: psicobiología, sustancias específicas, adicción tecnológica, juego patológico y herramientas clínicas para...",
        sobreTitulo: "Un abordaje integral de las adicciones",
        objetivos: ["Comprender la psicobiología de las adicciones, el sistema de recompensa cerebral y los mecanismos neurobiológicos de la conducta adictiva.", "Identificar y clasificar las distintas sustancias psicoactivas, sus efectos agudos y crónicos, y su abordaje según el DSM.", "Desarrollar habilidades clínicas para el diagnóstico, tratamiento interdisciplinario y prevención de las adicciones en distintas poblaciones.", "Explorar las nuevas formas de adicción —tecnológica y juego patológico— y comprender su impacto en ámbitos laborales, familiares y sociales."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Estudiantes último año de Medicina", "Graduados UBA", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Eduardo Henderson"],
        directorDetalle: ["Director · Médico Cirujano"],
        direccionAcademica: [
            { nombre: "Dr. Eduardo Henderson", detalle: "Director · Médico Cirujano" }
        ],
        codireccion: ["Dr. Antonio Pascale", "Dr. Pablo Fielitz"],
        codireccionDetalle: ["Co-Director de la Diplomatura", "Co-Director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dr. Antonio Pascale", detalle: "Co-Director de la Diplomatura" },
            { nombre: "Dr. Pablo Fielitz", detalle: "Co-Director de la Diplomatura" }
        ],
        equipoDocente: [],
        directorImg: [henderson],
        inicio: "03/08/2026",
        fin: "29/11/2026",
        diasHorarios: "Lunes 19 a 21 hs",
        quincenal: false,
        clases: 17,
        horas: 173,
        duracion: 5,
        unidades: 18,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina",
            "b) Ser graduado de la Universidad de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina",
            "c) Ser graduado de Universidades extranjeras con título de grado correspondiente a la carrera de Medicina",
            "d) Ser estudiante regular de último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 3,
        precioMP: 1020000,
        precioSuscripcionMP: 170000,
        precioTransferencia: 816000,
        precioPayPal: 750,
        precioSuscripcionPayPal: 125,
        precioTransferenciaUSA: 600,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=08a018ca69844042a7df98a6fdab34ec",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/IKk6JN72TjXb40yTfGxo0EMzyNrVQF56",
        cuposLlenos: true,
    },
    {
        id: 111,
        codigoT: "400.4",
        nombre: "Diplomatura en Nutrición Deportiva de Alto Rendimiento",
        foto: nutriDeportiva,
        url: "diplomatura-nutricion-deportiva",
        tipo: "Diplomatura",
        categoria: ["nutricion"],
        area: "Nutrición Deportiva",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Hoy en día sabemos que la práctica del ejercicio físico es fundamental para mejorar nuestra calidad de vida. Una dieta equilibrada es uno de los pilares para mantener un estilo de vida saludable y un rendimiento óptimo en cada actividad. El correcto asesoramiento nutricional junto a un adecuado plan alimentario mejorará ampliamente el rendimiento físico.",
        descripcionExtra: ["En esta Diplomatura contamos con un programa integral basado en las últimas actualizaciones científicas en el área de nutrición y salud deportiva. Brindaremos a cada alumno el conocimiento necesario para su correcta práctica diaria, tanto profesional como deportiva en cada disciplina."],
        descripcionPreview: "Formación integral y actualizada en nutrición aplicada al deporte: desde las bases moleculares hasta la suplementación, el metabolismo muscular y...",
        sobreTitulo: "Nutrición y rendimiento: el binomio del alto rendimiento",
        objetivos: ["Brindar los conocimientos actualizados sobre nutrición aplicada al deporte, con base en las últimas evidencias científicas.", "Conocer la estructura del músculo esquelético, comprendiendo su funcionamiento en profundidad y su relación con el rendimiento.", "Comprender los factores externos e internos que influyen en el abordaje nutricional individualizado de cada deportista.", "Capacitar para el correcto establecimiento de un plan de alimentación teniendo en cuenta la actividad específica a desarrollar."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Estudiantes universitarios", "Con título secundario"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora · (MN 163753) · Especialista en Nutrición"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora · (MN 163753) · Especialista en Nutrición" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Patricio Izal" },
            { titulo: "Prof.", nombre: "Soledad Álvarez" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dr.", nombre: "Raúl F. Pastor" }
        ],
        directorImg: [manfredi],
        inicio: "28/08/2026",
        fin: "18/12/2026",
        diasHorarios: "Viernes 18 a 20 hs",
        quincenal: false,
        clases: 17,
        horas: 173,
        duracion: 5,
        unidades: 10,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: ["Titulo Secundario"],
        modalidad: "Virtual",
        temario: 4,
        precioMP: 972000,
        precioSuscripcionMP: 162000,
        precioTransferencia: 777600,
        precioPayPal: 750,
        precioSuscripcionPayPal: 125,
        precioTransferenciaUSA: 600,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=7926aef70a97478b9bcdfb5e2b053161",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/lINpIUYeGA50WWoxxPIyrttzSWiZHdPn",
        cuposLlenos: false,
    },
    {
        id: 113,
        codigoT: "400.6",
        nombre: "Diplomatura en Nutrición y Diabetes Tipo 2",
        foto: diabetes,
        url: "diplomatura-nutricion-diabetes",
        tipo: "Diplomatura",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La nutrición tiene un papel fundamental en el estado de salud de las personas, sobre todo cuando padecen algún tipo de patología. Por lo cual, es necesario que los profesionales alcancen un dominio elevado en esta área, manteniendo de forma permanente una puesta al día que permita evaluar un tratamiento terapéutico adecuado para cada individuo.",
        descripcionExtra: ["Contamos con un programa completo mediante el cual, cada profesional recibirá todo el conocimiento actualizado y necesario sobre la nutrición clínica, pudiendo abordar cada paciente de una forma integral y personalizada."],
        descripcionPreview: "Programa actualizado en nutrición clínica para el abordaje integral del paciente con DBT tipo 2: fisiopatología, farmacología, planes...",
        sobreTitulo: "Nutrición clínica al servicio del paciente con diabetes",
        objetivos: ["Brindar los conocimientos científicos actualizados sobre diabetes tipo 2: fisiopatología, bioquímica, metabolismo y etiopatogenia.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud: cambios de estilo de vida, educación terapéutica y estrategias de adherencia.", "Aportar herramientas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida del paciente con DBT tipo 2.", "Capacitar en el diseño de planes nutricionales personalizados, integrando el abordaje farmacológico y no farmacológico de la patología."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Licenciadas/os en Nutrición", "Médicos", "Graduados UBA", "Otras universidades argentinas", "Universidades extranjeras"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora · (MN 163.753) · Especialista en Nutrición"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora · (MN 163.753) · Especialista en Nutrición" }
        ],
        codireccion: ["Prof. Dr. Raúl F. Pastor"],
        codireccionDetalle: ["Co-Director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Prof. Dr. Raúl F. Pastor", detalle: "Co-Director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Laura Iermoli" }
        ],
        directorImg: [pastor],
        codireccionImg: [pastor],
        inicio: "06/08/2026",
        fin: "03/12/2026",
        diasHorarios: "Jueves 20 a 22 hs",
        quincenal: true,
        clases: 8,
        horas: 170,
        duracion: 5,
        unidades: 8,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud."
        ],
        modalidad: "Virtual",
        temario: 6,
        precioMP: 800000,
        precioSuscripcionMP: 133333,
        precioTransferencia: 640000,
        precioPayPal: 600,
        precioSuscripcionPayPal: 100,
        precioTransferenciaUSA: 480,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=e850098951064e0e8ffb1e6f78ebf28c",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/m5khhTj3XfE2bKdhfICBAQFUcXSXR6Jf",
        cuposLlenos: false,
    },
    {
        id: 114,
        codigoT: "400.7",
        nombre: "Diplomatura en Nutrición y Microbiota",
        foto: nutriMicrobiota,
        url: "diplomatura-nutricion-microbiota",
        tipo: "Diplomatura",
        categoria: ["nutricion"],
        area: "Nutrición y Microbiota",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La microbiota es quizás uno de los tópicos más interesantes y a su vez menos estudiado por los profesionales de la salud. Ha tomado extrema relevancia en investigación científica hace más de 20 años, intentando trasladar hipótesis muy fuertes al ámbito de la ciencia.",
        descripcionExtra: ["La nutrición tiene un papel fundamental en el estado de la microbiota intestinal, sobre todo cuando el paciente padece algún tipo de patología. Es necesario que los profesionales alcancen un dominio elevado en esta área, manteniendo de forma permanente una puesta al día, permitiendo realizar un tratamiento adecuado, fomentando el desarrollo de los microorganismos benéficos y disminuyendo los patógenos.", "Contamos con un programa completo mediante el cual cada profesional recibirá todo el conocimiento actualizado y necesario para poder abordar cada paciente de una forma integral y personalizada."],
        descripcionPreview: "Formación integral y actualizada sobre el rol de la microbiota en la salud, con herramientas para un abordaje clínico personalizado. Doble...",
        sobreTitulo: "La microbiota como pilar fundamental del estado de salud",
        objetivos: ["Brindar al profesional los conocimientos científicos actualizados sobre la Microbiota.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud abordando cambios en el estilo de vida, educación terapéutica, estrategias de adherencia, acompañamiento terapéutico (farmacológico y no farmacológico) y familiar.", "Aportar a los profesionales nuevas herramientas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida de cada paciente para lograr un óptimo objetivo."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Lic. en Nutrición", "Médicos de Familia", "Clínicos", "Generalistas", "Endocrinología", "Psiquiatría", "Cardiología", "Graduados UBA y otras universidades"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora de la Diplomatura · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora de la Diplomatura · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor (Co-Director)" },
            { titulo: "Dr.", nombre: "Roberto H. Iermoli" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dra.", nombre: "Maria Piekar" },
            { titulo: "Dra.", nombre: "Luciana Vasconsellos" },
            { titulo: "Dra.", nombre: "Victoria Cólica" }
        ],
        directorImg: [manfredi],
        inicio: "07/08/2026",
        fin: "04/12/2026",
        diasHorarios: "Viernes 18 a 20 hs",
        quincenal: false,
        clases: 17,
        horas: 175,
        duracion: 5,
        unidades: 13,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud."
        ],
        modalidad: "Virtual",
        temario: 7,
        precioMP: 1430000,
        precioSuscripcionMP: 239000,
        precioTransferencia: 1144000,
        precioPayPal: 900,
        precioSuscripcionPayPal: 150,
        precioTransferenciaUSA: 720,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=68cd58d68e21492498c1a5175677fbcc",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/fpsIBkr3aRSeGYgN6qMAaBjHfzUziEUo",
        cuposLlenos: false,
    },
    {
        id: 101,
        codigoT: "400.1",
        nombre: "Diplomatura en Urgencias Neurocardiológicas",
        foto: neurocardio,
        url: "diplomatura-urgencias-neurocardiologicas",
        tipo: "Diplomatura",
        categoria: ["neurologia", "emergencias"],
        area: "Urgencias",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La enfermedad cardiovascular es la primera causa de mortalidad a nivel mundial, y en Argentina el 25% de las muertes son atribuibles a enfermedades del sistema circulatorio. El accidente cerebrovascular, por su parte, es la primera causa de discapacidad a nivel global, y la OMS estima un aumento del 20% en su incidencia para 2040.",
        descripcionExtra: ["Esta diplomatura forma profesionales con competencias esenciales para la identificación temprana, evaluación precisa y aplicación de intervenciones urgentes en situaciones neurocardiológicas críticas. La interconexión entre los sistemas cardiovascular y neurovascular exige un enfoque multidisciplinario, colaborativo y basado en la evidencia más actualizada."],
        descripcionPreview: "Formación avanzada en el manejo de emergencias cardiovasculares y neurovasculares: infarto, ACV, arritmias, shock cardiogénico y más. Titulación...",
        sobreTitulo: "Urgencias neurocardiológicas: una necesidad crítica",
        objetivos: ["Proporcionar conocimientos sólidos sobre bases teóricas y prácticas de las urgencias neurocardiológicas para mejorar la comprensión integral de estas situaciones críticas.", "Desarrollar habilidades clínicas avanzadas: evaluación rápida, diagnóstico preciso y aplicación de protocolos de tratamiento actualizados.", "Capacitar en la identificación temprana de signos y síntomas e interpretación de pruebas diagnósticas para optimizar los tiempos de intervención.", "Fomentar el trabajo interdisciplinario y la comunicación efectiva para mejorar la coordinación y la calidad de la atención en urgencias.", "Desarrollar habilidades de liderazgo y toma de decisiones efectivas en situaciones de urgencias neuro-cardio-vasculares.", "Actualizar en los avances tecnológicos y terapéuticos del campo, integrando las últimas evidencias científicas en la práctica clínica."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos Cardiólogos", "Médicos Neurólogos", "Médicos Clínicos", "Especialistas en Terapia Intensiva", "Médicos Emergentólogos", "Médicos de Familia", "Estudiantes último año de Medicina"],
        director: ["Dr. Matías J. Alet"],
        directorDetalle: ["Director · (M.N. 137234) · Neurólogo"],
        direccionAcademica: [
            { nombre: "Dr. Matías J. Alet", detalle: "Director · (M.N. 137234) · Neurólogo" }
        ],
        codireccion: ["Dra. Natalia Zareba"],
        codireccionDetalle: ["Co-directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dra. Natalia Zareba", detalle: "Co-directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Julieta Rosales" },
            { titulo: "Dr.", nombre: "Ignacio Petel" },
            { titulo: "Dra.", nombre: "Agustina Zavattieri" },
            { titulo: "Dra.", nombre: "Jimena Gambarte" },
            { titulo: "Dra.", nombre: "Mariana Mazzei" },
            { titulo: "Dr.", nombre: "Ignacio Rios" },
            { titulo: "Dra.", nombre: "Sofia Razzini" },
            { titulo: "Dr.", nombre: "Herrera Paz" }
        ],
        directorImg: [alet],
        codireccionImg: [zareba],
        inicio: "07/08/2026",
        fin: "04/12/2026",
        diasHorarios: "Viernes 20 a 22 hs",
        quincenal: true,
        clases: 8,
        horas: 170,
        duracion: 5,
        unidades: 10,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina.",
            "d) Ser estudiante regular del último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 1,
        precioMP: 1300000,
        precioSuscripcionMP: 217000,
        precioTransferencia: 1040000,
        precioPayPal: 750,
        precioSuscripcionPayPal: 125,
        precioTransferenciaUSA: 600,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=091280e2163b40559fa09299ba372a68",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/eiFGM3BhNOCbuocsM7peXZx8oHFw15zw",
        cuposLlenos: true,
    },
    {
        id: 102,
        codigoT: "400.2",
        nombre: "Diplomatura en Bioremodelación Facial",
        foto: bioFacial,
        url: "diplomatura-bioremodelacion-facial",
        tipo: "Diplomatura",
        categoria: ["dermatologia"],
        area: "Bioremodelación Facial",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Se estudia la anatomía facial, la estructura y función de los músculos faciales, los puntos de inyección, la anatomía vascular e inervación del rostro. Se exploran los mecanismos de acción de la toxina botulínica tipo A, las dosis adecuadas, reconstitución y precauciones.",
        descripcionExtra: ["Se enseñan las técnicas adecuadas para administrar toxina botulínica A y los diferentes tipos de implantes de ácido hialurónico y fillers semipermanentes. Se aprende a evaluar pacientes, identificar necesidades estéticas y diseñar planes de tratamiento personalizados, incluyendo el manejo de complicaciones."],
        descripcionPreview: "Toxina botulínica tipo A, ácido hialurónico, fillers semipermanentes, rinoremodelación y tratamientos complementarios. Formación teórica y...",
        sobreTitulo: "Dominio integral de la bioremodelación facial",
        objetivos: ["Adquirir conocimientos teóricos sobre anatomía facial, farmacología de la toxina botulínica tipo A y técnicas de inyección.", "Aprender a evaluar pacientes, identificar necesidades y diseñar planes de tratamientos individualizados.", "Familiarizarse con precauciones, medidas de seguridad y manejo de posibles complicaciones.", "Optimizar el conocimiento de ácido hialurónico, hidroxiapatita de calcio y fillers semipermanentes."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Trabajos prácticos", "Práctica final presencial (04/12/2026)", "Examen final"],
        destinatarioTags: ["Médicos/as", "Odontólogos/as", "Estudiantes último año (Medicina/Odontología)"],
        director: ["Dr. Diego Slipak"],
        directorDetalle: ["Director · (MN 162.822) · Dermatólogo"],
        direccionAcademica: [
            { nombre: "Dr. Diego Slipak", detalle: "Director · (MN 162.822) · Dermatólogo" }
        ],
        codireccion: ["Dr. Ricardo Lingua"],
        codireccionDetalle: ["Co-Director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dr. Alfredo Ruíz Díaz", detalle: "Co-Director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Sylvia B. Pingitore" },
            { titulo: "Dr.", nombre: "Ruíz Díaz" }
        ],
        directorImg: [slipakhijo],
        codireccionImg: [lingua],
        inicio: "05/08/2026",
        fin: "02/12/2026",
        "practica final": "04/12/2026",
        diasHorarios: "Miércoles 20 a 22 hs",
        quincenal: false,
        clases: 17,
        horas: 170,
        duracion: 5,
        unidades: 14,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina u Odontología.",
            "d) Ser estudiante regular del último año de la carrera de Medicina u Odontología."
        ],
        modalidad: "Virtual",
        temario: 2,
        precioMP: 1800000,
        precioSuscripcionMP: 300000,
        precioTransferencia: 1440000,
        precioPayPal: 1200,
        precioSuscripcionPayPal: 200,
        precioTransferenciaUSA: 960,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=77fa07c55c9f4909939b52a1e20a3df3",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/NKzHkSIvoyLdYcR7Qqq3NSFRctZwsHam",
        cuposLlenos: false,
    },
    {
        id: 142,
        codigoT: "400.33",
        nombre: "Diplomatura en Microtrasplante Capilar",
        foto: capilar,
        url: "diplomatura-microtrasplante-capilar",
        tipo: "Diplomatura",
        categoria: ["dermatologia"],
        area: "Trasplante Capilar",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "El Diplomado en Microtrasplante Capilar combina clases virtuales intensivas con práctica hands-on full sobre pacientes reales, en grupos limitados que garantizan una capacitación personalizada. El programa abarca desde las ciencias básicas y la tricología clínica hasta la planificación quirúrgica, las técnicas de extracción e implantación y el manejo postoperatorio.",
        descripcionExtra: [
            "El abordaje es teórico-práctico: el cursante domina la técnica más avanzada y utilizada en la actualidad (F.U.E.) con un enfoque funcional y estético, capacitándose en el manejo integral de la alopecia desde el diagnóstico clínico y los tratamientos médicos no invasivos hasta la intervención quirúrgica."
        ],
        descripcionPreview: "Dominá la técnica FUE de microtrasplante capilar con enfoque funcional y estético. Manejo integral de la alopecia: del diagnóstico clínico...",
        sobreTitulo: "Formación integral en trasplante capilar FUE",
        objetivos: [
            "Identificar y clasificar los distintos tipos de alopecia mediante herramientas diagnósticas y estudios complementarios.",
            "Prescribir tratamientos médicos no invasivos (farmacoterapia y bioestimulación) basados en la evidencia científica actual.",
            "Diseñar líneas frontales y áreas de cobertura con criterio estético, respetando la anatomía y las diferencias de género.",
            "Ejecutar la extracción, manipulación y colocación de unidades foliculares bajo altos estándares de seguridad, garantizando resultados naturales y de alta densidad."
        ],
        sistemaEvaluacion: ["Práctica final hands-on sobre pacientes reales"],
        destinatarioTags: ["Médicos generales", "Médicos estéticos", "Dermatólogos", "Otras especialidades médicas"],
        director: ["Dr. Alfredo Ruiz Diaz"],
        directorDetalle: ["Director de la Diplomatura · Director de Medicina Estética y Regenerativa FISP · Cirugía Plástica, Estética y Reconstructiva · Docente Internacional en Trasplante y Recuperación Capilar"],
        direccionAcademica: [
            {
                nombre: "Dr. Alfredo Ruiz Diaz",
                detalle: "Director de la Diplomatura · Director de Medicina Estética y Regenerativa FISP · Cirugía Plástica, Estética y Reconstructiva · Docente Internacional en Trasplante y Recuperación Capilar",
            }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Diego Slipak" }
        ],
        directorImg: [],
        inicio: "31/08/2026",
        fin: "05/09/2026",
        "practica final": "04/09/2026 y 05/09/2026",
        diasHorarios: "Cronograma intensivo",
        quincenal: false,
        clases: 8,
        horas: null,
        duracion: null,
        unidades: 8,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [null],
        modalidad: "Virtual + práctica presencial",
        temario: 33,
        precioMP: 3100000,
        precioSuscripcionMP: 1100000,
        precioTransferencia: 2480000,
        precioPayPal: 0,
        precioSuscripcionPayPal: 0,
        precioTransferenciaUSA: 0,
        cuotas: 3,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=e05d491c540a41daa2124c8560696142",
        linkSuscripcionDlocal: null,
        pageContent: {
            heroBadge: "Solo 5 vacantes · 2026",
            dataCardTitle: "Datos del programa",
            heroFacts: [
                ["🎓", "Titulación", "FISP + Fac. Medicina UBA"],
                ["💻", "Modalidad", "Virtual + Práctica presencial"],
                ["📚", "Módulos", "8 módulos"],
                ["🤝", "Práctica", "Hands-on con pacientes reales"],
                ["🔒", "Vacantes", "Solo 5 cupos"],
            ],
            infoBarItems: [
                "🩺 Dirigida por el Dr. Alfredo Ruiz Diaz",
                "🎓 Doble titulación FISP + Facultad de Medicina UBA",
                "🔒 Cupos limitados: solo 5 vacantes",
            ],
            aboutTag: "Sobre la diplomatura",
            aboutTitle: "Formación integral en trasplante capilar FUE",
            objectivesTag: "Objetivos del programa",
            audienceTag: "¿A quién está dirigido?",
            temarioHeading: "8 módulos · Teórico-Práctico",
            methodCards: [
                {
                    icon: "📹",
                    title: "Clases virtuales intensivas",
                    text: "Contenido teórico online con docentes especializados en trasplante capilar.",
                },
                {
                    icon: "🤝",
                    title: "Práctica hands-on full",
                    text: "Práctica presencial sobre pacientes reales los días 4 y 5 de septiembre.",
                },
                {
                    icon: "🔒",
                    title: "Grupos limitados",
                    text: "Solo 5 vacantes para garantizar una capacitación personalizada.",
                },
            ],
            showAudienceTags: true,
            sidebarFactsTitle: "Ficha del programa",
            sidebarFacts: [
                ["Programa", "Diplomatura"],
                ["Área", "Trasplante Capilar"],
                ["Módulos", "8"],
                ["Modalidad", "Virtual + Presencial"],
                ["Inicio cursada", "31/08/2026"],
                ["Prácticas presenciales", "4 y 5/09/2026"],
                ["Vacantes", "Solo 5"],
            ],
            sidebarNote: "Cupos muy limitados. Capacitación personalizada.",
            certificationTitle: "Doble titulación",
            certificationDescription:
                "Certificado de Diplomatura emitido por FISP y la Facultad de Medicina de la Universidad de Buenos Aires.",
        },
        cuposLlenos: false,
    },
    {
        id: 171,
        codigoT: "400.18",
        nombre: "Diplomatura en Criminalística y Ciencias Forenses",
        foto: forense,
        url: "diplomatura-criminalistica-ciencias-forenses",
        tipo: "Diplomatura",
        categoria: ["criminalistica"],
        area: "Criminalística / Forense",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "La investigación de un hecho criminal reviste una importancia fundamental no solo para el esclarecimiento del mismo sino para proveer los servicios de justicia que demanda la sociedad, logrando satisfacer la obligación del Estado en materia de seguridad y prevención del delito.",
        descripcionExtra: ["La complejidad inherente a esta labor demanda una intervención técnico-científica de carácter interdisciplinario donde participan la criminología, la criminalística, la medicina legal y demás ciencias del espectro forense. Esta diplomatura busca proporcionar las herramientas teóricas y prácticas necesarias para abordar estas complejidades con rigurosidad, eficacia y compromiso ético."],
        descripcionPreview: "Formación interdisciplinaria en ciencias forenses, criminalística, medicina legal, tanatología, lesionología, patología forense y abordajes...",
        sobreTitulo: "Investigación criminal con rigor científico",
        objetivos: ["Conocimiento y comprensión de las ciencias forenses, la criminalística, la medicina legal, la tanatología, la lesionología, la radiología y la patología forense.", "Desarrollar una visión integral en el abordaje de la investigación criminal.", "Conocimientos básicos en relación al estudio médico legal y criminalístico de las lesiones y de la muerte.", "Habilidades para desenvolverse en peritaciones vinculadas a abordajes criminalísticos, médico-legales y autopsias medicolegales."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud", "Estudiantes último año (Medicina)", "Profesionales de otras carreras", "Universidades argentinas y extranjeras"],
        director: ["Dr. Santiago Maffia Bizzozero"],
        directorDetalle: ["Director · (M.N. 109205) · Médico especialista en medicina legal · Director Médico de la morgue judicial de la Nación Argentina"],
        direccionAcademica: [
            { nombre: "Dr. Santiago Maffia Bizzozero", detalle: "Director · (M.N. 109205) · Médico especialista en medicina legal · Director Médico de la morgue judicial de la Nación Argentina" }
        ],
        codireccion: ["Dr. Alejandro E. Vega"],
        codireccionDetalle: ["Co-director de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Dr. Alejandro E. Vega", detalle: "Co-director de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Matías E. Saldeña" },
            { titulo: "Dra.", nombre: "Matilde Buzzi" },
            { titulo: "Dr.", nombre: "Pablo Bustelo" },
            { titulo: "Dr.", nombre: "Alejandro E. Vega" },
            { titulo: "Bioq.", nombre: "Natalia Bardoni" },
            { titulo: "Lic.", nombre: "Sofía Egaña" },
            { titulo: "Lic.", nombre: "Belén Spada" },
            { titulo: "Lic.", nombre: "Abel I. Cunto" }
        ],
        directorImg: [maffia],
        inicio: "03/08/2026",
        fin: "30/11/2026",
        diasHorarios: "Lunes 20 a 22 hs",
        quincenal: false,
        clases: 17,
        horas: 173,
        duracion: 5,
        unidades: 4,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de la Universidad de Buenos Aires con título de grado correspondiente a la carrera de Medicina.",
            "b) Ser graduado de otras universidades argentinas con título de grado correspondiente a la carrera de Medicina.",
            "c) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina.",
            "d) Ser estudiante regular del último año de la carrera de Medicina."
        ],
        modalidad: "Virtual",
        temario: 18,
        precioMP: 1110000,
        precioSuscripcionMP: 185000,
        precioTransferencia: 888000,
        precioPayPal: 750,
        precioSuscripcionPayPal: 125,
        precioTransferenciaUSA: 600,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=5c015291333343038e9483e43bca5b59",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/YThTLk9CQ9G13DwUQRcRreXfW4An3zAm",
        cuposLlenos: false,
    },
    {
        id: 151,
        codigoT: "400.16",
        nombre: "Diplomatura en Ginecología Regenerativa, Estética y Funcional",
        foto: ginecologia,
        url: "diplomatura-ginecologia-regenerativa-estetica-funcional",
        tipo: "Diplomatura",
        categoria: ["ginecologia"],
        area: "Ginecología Regenerativa",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La ginecología regenerativa, estética y funcional representa una evolución en la atención de la salud íntima femenina, respondiendo a una creciente demanda de tratamientos que aborden no sólo patologías, sino también aspectos funcionales y estéticos que impactan significativamente la calidad de vida y la autoestima de las mujeres.",
        descripcionExtra: ["Esta diplomatura surge para llenar la brecha en la formación tradicional, ofreciendo una capacitación integral y especializada que abarca desde la fisiología del envejecimiento genital y la microbiota, hasta el dominio de terapias bioregenerativas, inyectables, energéticas y procedimientos quirúrgicos mínimamente invasivos."],
        descripcionPreview: "Terapias bioregenerativas, inyectables, energéticas y cirugía cosmetoginecológica. Abordaje integral de la salud íntima femenina con enfoque...",
        sobreTitulo: "Evolución en la atención de la salud íntima femenina",
        objetivos: ["Integrar conocimientos estéticos, funcionales y regenerativos en el abordaje ginecológico, optimizando la función genital femenina.", "Abordar de manera integral los trastornos del suelo pélvico, el disconfort vulvar y el impacto en la calidad de vida sexual.", "Valorar la importancia de la ginecoestética en su aspecto funcional y estético para evaluación, diagnóstico y tratamiento.", "Desarrollar criterio clínico para seleccionar estrategias terapéuticas priorizando seguridad, evidencia y bienestar de la paciente."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Ginecología", "Tocoginecología", "Obstetricia", "Urología", "Residentes último año"],
        director: ["Dra. Camila Enei"],
        directorDetalle: ["Directora · (MN 166563) · Tocoginecóloga"],
        direccionAcademica: [
            { nombre: "Dra. Camila Enei", detalle: "Directora · (MN 166563) · Tocoginecóloga" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Cecilia Ruiz" },
            { titulo: "Dra.", nombre: "Barbara Durand" },
            { titulo: "Dra.", nombre: "Maria Denari" },
            { titulo: "Dra.", nombre: "Gisella Perochena" },
            { titulo: "Dra.", nombre: "Melania Thiermann" },
            { titulo: "Dra.", nombre: "Mercedes Fiuza" },
            { titulo: "Dra.", nombre: "Macarena Alimón" }
        ],
        directorImg: [enei],
        inicio: "04/08/2026",
        fin: "01/12/2026",
        diasHorarios: "Martes 18 a 20 hs",
        quincenal: false,
        clases: 17,
        horas: 175,
        duracion: 5,
        unidades: 4,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser médico graduado de la Universidad de Buenos Aires con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología.",
            "b) Ser médico graduado de otras universidades argentinas con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología.",
            "c) Ser médico graduado de universidades extranjeras con título habilitante y formación de posgrado (especialidad finalizada o en curso en el último año de residencia) en Ginecología, Tocoginecología, Obstetricia o Urología."
        ],
        modalidad: "Virtual",
        temario: 16,
        precioMP: 1400000,
        precioSuscripcionMP: 235000,
        precioTransferencia: 1120000,
        precioPayPal: 900,
        precioSuscripcionPayPal: 150,
        precioTransferenciaUSA: 720,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=149717d0d1634533b56de473de62a961",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/n0HOvRS2LjLW0BmGbOrADngjU30Gi7ce",
        cuposLlenos: false,
    },
    {
        id: 131,
        codigoT: "400.13",
        nombre: "Diplomatura en Inteligencia Artificial Médica",
        foto: ia,
        url: "diplomatura-ia-medica",
        tipo: "Diplomatura",
        categoria: ["tecnologia", "medicina-de-precision"],
        area: "IA Médica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Las ciencias médicas se enfrentan a grandes y crecientes retos: el gasto en salud aumentó un 40% entre 2018 y 2022, la escasez de personal de salud lleva a la sobrecarga del personal existente, y el envejecimiento poblacional incrementa la demanda de atención.",
        descripcionExtra: ["La Inteligencia Artificial representa no solo un avance tecnológico prometedor, sino una posible respuesta a múltiples problemáticas. La OMS reconoce su valor y juega un papel activo en convertirla en una herramienta integrada de los sistemas de salud. Hoy la IA se encuentra en práctica clínica, investigación biomédica, salud pública y administración."],
        descripcionPreview: "Desde los fundamentos de la IA hasta su aplicación en diagnóstico, cirugía, oncología e investigación biomédica. Elaboración de proyectos en IA...",
        sobreTitulo: "La IA como respuesta a los desafíos de la salud",
        objetivos: ["Brindar conocimientos fundamentales y sólidos sobre IA, desde sus fundamentos básicos hasta su aplicación en salud.", "Aportar los conocimientos necesarios para la elaboración y planeamiento de proyectos en IA.", "Equipar al profesional con herramientas para planificar y ejecutar proyectos innovadores en IA dentro del sector sanitario."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Estudiantes último año (otras)"],
        director: ["Dr. Paolo Lauretta"],
        directorDetalle: ["Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)"],
        direccionAcademica: [
            { nombre: "Dr. Paolo Lauretta", detalle: "Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Santiago Maffia" },
            { titulo: "Ing.", nombre: "Alberto Ortega" },
            { titulo: "Dra.", nombre: "Karina Formoso" },
            { titulo: "Dra.", nombre: "Jesica Formoso" }
        ],
        directorImg: [lauretta],
        inicio: "04/08/2026",
        fin: "30/11/2026",
        diasHorarios: "Martes 20 a 22 hs",
        quincenal: false,
        clases: 17,
        horas: 175,
        duracion: 5,
        unidades: 9,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado",
            "b) Ser graduado de universidades extranjeras con título de grado",
            "c) Ser estudiante regular de último año de carrera."
        ],
        modalidad: "Virtual",
        temario: 13,
        precioMP: 1500000,
        precioSuscripcionMP: 250000,
        precioTransferencia: 1200000,
        precioPayPal: 1000,
        precioSuscripcionPayPal: 170,
        precioTransferenciaUSA: 800,
        precioRegularPayPalEspana: 1000,
        precioUnPagoPayPalEspana: 800,
        precioSuscripcionPayPalEspana: 170,
        linkPayPalEspana: "https://www.paypal.com/ncp/payment/ZBZBWHLE3XU3J",
        linkSuscripcionPayPalEspana: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-0DF04166VD2015617ND5HQWY",
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=f66c273e8eed48f99f43a23ad443ca96",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/SqGVvNddjyH4EqKZKrN049kljvYb24IY",
        cuposLlenos: false,
    },
    {
        id: 141,
        codigoT: "400.15",
        nombre: "Diplomatura en Medicina Laboral Especializada en Energía y Minería",
        foto: medicinaLaboral,
        url: "diplomatura-medicina-laboral-energia-mineria",
        tipo: "Diplomatura",
        categoria: ["medicina-laboral"],
        area: "Medicina Laboral",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La diplomatura aborda el contexto del trabajo en hidrocarburos y minería, los agentes de riesgo del sector, el diagnóstico clínico y el nexo causal, junto con las herramientas de vigilancia, prevención y el marco legal que encuadra la práctica profesional.",
        descripcionExtra: [
            "El eje de territorio atraviesa todos los módulos: emergencias médicas en campo, gestión del enfermo crónico alejado del centro de salud y telemedicina en zonas remotas.",
            "Formación integral en toxicología industrial, enfermedades profesionales, vigilancia médica, emergencias en campo y marco legal del sector extractivo."
        ],
        descripcionPreview: "Toxicología industrial, enfermedades profesionales, vigilancia médica, emergencias en campo, telemedicina en zonas remotas y marco legal del sector...",
        sobreTitulo: "El médico en la industria extractiva",
        objetivos: [
            "Comprender el contexto, magnitud y particularidades del trabajo en hidrocarburos y minería, incluyendo Vaca Muerta y la minería metalífera.",
            "Dominar la toxicología de los principales agentes de riesgo: benceno, sílice, H2S, NORM, ruido industrial y estrés térmico.",
            "Diagnosticar enfermedades profesionales, establecer nexo causal y documentar informes médico-legales con criterios de Bradford Hill.",
            "Manejar emergencias médicas e industriales en campo, telemedicina en zonas remotas y criterios de evacuación."
        ],
        sistemaEvaluacion: [
            "Evaluación integradora asincrónica por módulo (cuestionario + caso clínico)",
            "Actividad en foro",
            "Trabajo final integrador (Módulo 9)",
            "Aprobación: 70% de cada módulo + presentación del trabajo final"
        ],
        destinatarioTags: [
            "Médicos laborales",
            "Médicos auditores",
            "Médicos de empresa (extractivos)",
            "Higiene y seguridad",
            "Médicos generalistas"
        ],
        director: ["Dr. Juan Carchini"],
        directorDetalle: ["Director Médico de FISP · (M.N. 111923)"],
        direccionAcademica: [
            { nombre: "Dr. Juan Carchini", detalle: "Director Médico de FISP · (M.N. 111923)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            {
                titulo: "Dr.",
                nombre: "Sergio Santillán",
                detalle: "Médico laboral especialista en yacimientos y mineras",
            },
            {
                titulo: "Dr.",
                nombre: "Nazario Boldo",
                detalle: "Médico Psiquiatra y Legista en riesgos del trabajo",
            },
            {
                titulo: "Dr.",
                nombre: "Francisco Dadic",
                detalle: "Director de Toxicología de FISP",
            },
        ],
        directorImg: [carchini],
        inicio: "18/08/2026",
        fin: "15/12/2026",
        diasHorarios: "Martes 20hs",
        quincenal: false,
        clases: null,
        horas: 210,
        duracion: 5,
        unidades: 9,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [null],
        modalidad: "Virtual",
        temario: 32,
        descuentoUnPagoSoloConCodigo: true,
        precioMP: 1300000,
        precioSuscripcionMP: 217000,
        precioTransferencia: 1040000,
        precioPayPal: 1000,
        precioSuscripcionPayPal: 1,
        precioTransferenciaUSA: 800,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=c3d2f4bf071b47749f39cb916f730312",
        linkSuscripcionDlocal: "",
        cuposLlenos: false,
    },
    {
        id: 161,
        codigoT: "400.17",
        nombre: "Diplomatura en Marketing Médico",
        foto: marketing,
        url: "diplomatura-marketing-medico",
        tipo: "Diplomatura",
        categoria: ["marketing"],
        area: "Marketing Médico",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "El contexto actual de la salud se encuentra atravesado por transformaciones profundas: la digitalización de la información, el acceso masivo a contenidos médicos por parte de los pacientes, la creciente competitividad entre instituciones sanitarias y la necesidad de generar confianza en un entorno de sobreinformación.",
        descripcionExtra: ["El marketing médico se constituye como una disciplina estratégica que permite a los profesionales y organizaciones del sector diferenciarse, comunicar con claridad y sostener relaciones basadas en la confianza y la ética. La Diplomatura ofrece un espacio académico que articula teoría y práctica, con énfasis en la aplicación real y contextualizada de estrategias de marketing en el ámbito sanitario."],
        descripcionPreview: "Estrategias de marketing aplicadas al sector salud: marca personal, redes sociales, publicidad digital, IA y gestión de consultorios. Titulación...",
        sobreTitulo: "Marketing estratégico para el sector salud",
        objetivos: ["Comprender los fundamentos del marketing aplicado al sector salud, diferenciando las particularidades de la comunicación sanitaria.", "Incorporar metodologías de diagnóstico estratégico (FODA, SMART, Canvas) aplicadas al campo sanitario.", "Desarrollar la marca personal y profesional en salud, fortaleciendo la identidad, tono de voz y valores diferenciales.", "Capacitar en el uso de herramientas digitales y presenciales de comunicación, fomentando un posicionamiento ético y sustentable.", "Analizar el comportamiento del paciente como usuario de servicios de salud en la era digital.", "Promover la innovación en la relación médico-paciente, incorporando casos reales de aciertos y errores."],
        sistemaEvaluacion: ["Un examen parcial", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Profesionales de la salud", "Estudiantes último año (salud)", "Profesionales de otras carreras", "Título secundario"],
        director: ["Lic. Aldana Daniela Farinelli"],
        directorDetalle: ["Directora de la Diplomatura · Lic. Comunicación Social · Directora Ejecutiva de FISP"],
        direccionAcademica: [
            { nombre: "Lic. Aldana Daniela Farinelli", detalle: "Directora de la Diplomatura · Lic. Comunicación Social · Directora Ejecutiva de FISP" }
        ],
        codireccion: ["Lic. María Paz Torres"],
        codireccionDetalle: ["Co-directora de la Diplomatura"],
        codireccionAcademica: [
            { nombre: "Lic. María Paz Torres", detalle: "Co-directora de la Diplomatura" }
        ],
        equipoDocente: [
            { titulo: "Lic.", nombre: "María Paz Torres" },
            { titulo: "Dra.", nombre: "Jimena Le Bellot" },
            { titulo: "Lic.", nombre: "Agustina Durigon" },
            { titulo: "Ing.", nombre: "Noelia Kempff" },
            { titulo: "", nombre: "Sofía Ciardelli" },
            { titulo: "Dr.", nombre: "Paolo Lauretta" },
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "", nombre: "Zahira Díaz" },
            { titulo: "", nombre: "Eliana Gagliano" }
        ],
        directorImg: [farinelli],
        inicio: "03/08/2026",
        fin: "14/12/2026",
        diasHorarios: "Lunes 18 a 20 hs",
        quincenal: false,
        clases: 17,
        horas: 175,
        duracion: 5,
        unidades: 15,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "Título secundario"
        ],
        modalidad: "Virtual",
        temario: 17,
        precioMP: 900000,
        precioSuscripcionMP: 150000,
        precioTransferencia: 720000,
        precioPayPal: 700,
        precioSuscripcionPayPal: 117,
        precioTransferenciaUSA: 560,
        precioRegularPayPalEspana: 700,
        precioUnPagoPayPalEspana: 560,
        precioSuscripcionPayPalEspana: 117,
        linkPayPalEspana: "https://www.paypal.com/ncp/payment/RCYFZBWDUY7MS",
        linkSuscripcionPayPalEspana: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-1FL18583X1000790WNJVWQHY",
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=c0d479467ade4273831136e2f89b22da",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/VCkg8i2eKyspTAfWTPHXTwTH3tbiaaXa",
        cuposLlenos: false,
    },
    {
        id: 234,
        codigoT: "400.26",
        nombre: "Posgrado en Big Data e IA en Salud",
        foto: bigData,
        url: "posgrado-bigdata-ia-salud",
        tipo: "Posgrado",
        categoria: ["tecnologia", "medicina-de-precision"],
        area: "Big Data e IA",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Profesionales de la salud y estudiantes del último año vinculados al área salud, según los destinatarios del programa." },
            { certificacion: "FISP", aplicaA: "Profesionales de otras carreras, estudiantes u otros perfiles indicados en los destinatarios del programa." }
        ],
        descripcion: "Actualmente, las ciencias médicas se enfrentan a grandes y crecientes retos. La Inteligencia Artificial representa no solo un avance tecnológico prometedor, sino una posible respuesta a múltiples problemáticas. La Organización Mundial de la Salud reconoce el valor de la IA y juega un papel activo en convertirla en una herramienta integrada de los sistemas de salud.",
        descripcionExtra: ["La ciencia de datos es fundamental para el desarrollo y aplicación de la IA, ya que proporciona las herramientas y metodologías necesarias para transformar grandes volúmenes de información en conocimiento útil. El increíble potencial de esta tecnología nos obliga a su desarrollo constante, brindando educación de calidad a profesionales de la salud."],
        descripcionPreview: "Conocimientos fundamentales y sólidos acerca de la ciencia de datos orientada a salud e Inteligencia Artificial, desde sus fundamentos básicos...",
        sobreTitulo: "Ciencia de datos e Inteligencia Artificial al servicio de la salud",
        objetivos: ["Brindar al profesional los conocimientos fundamentales y sólidos acerca de la ciencia de datos orientada a salud e Inteligencia Artificial (IA), desde sus fundamentos básicos hasta el alcance de su aplicación en salud."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud", "Profesionales de otras carreras con título de grado", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Paolo Lauretta"],
        directorDetalle: ["Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)"],
        direccionAcademica: [
            { nombre: "Dr. Paolo Lauretta", detalle: "Director de Salud Digital de FISP · Artificial Intelligence in Health Care (MIT)" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Jesica Formoso (Co-Directora)", detalle: "Investigadora Conicet - Data Science - R - Phyton", },
            { titulo: "Lic.", nombre: "Karina Formoso (Co-Directora)", detalle: "Investigadora Conicet - Biotecnóloga", },
            { titulo: "Ing.", nombre: "Alberto Ortega", detalle: "Digital Native Account Manager @ AWS" }
        ],
        directorImg: [lauretta],
        inicio: "25/08/2026",
        fin: "13/07/2027",
        diasHorarios: "Martes 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 340,
        duracion: 10,
        unidades: 8,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud.",
            "c) Ser graduado de universidades argentinas con título de otras carreras profesionales.",
            "d) Ser graduado de universidades extranjeras con título de otras carreras profesionales.",
        ],
        modalidad: "Virtual",
        temario: 26,
        precioMP: 4200000,
        precioSuscripcionMP: 350000,
        precioTransferencia: 3360000,
        precioPayPal: 2800,
        precioSuscripcionPayPal: 235,
        precioTransferenciaUSA: 2240,
        precioRegularPayPalEspana: 2800,
        precioUnPagoPayPalEspana: 2240,
        precioSuscripcionPayPalEspana: 235,
        linkPayPalEspana: "https://www.paypal.com/ncp/payment/LNMG74FAE2BTQ",
        linkSuscripcionPayPalEspana: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7U154641LU9385310ND5HLCA",
        cuotas: 12,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=f3d795b757ee4bf7891390e4cf6f868e",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/KpEmT76kwyWNvxRerBRPrRMLP6bFJxvv",
        cuposLlenos: false,
    },
    {
        id: 204,
        codigoT: "400.19",
        nombre: "Posgrado en Dermatología Estética y Terapéutica",
        foto: dermatologia,
        url: "posgrado-dermatologia-estetica-terapeutica",
        tipo: "Posgrado",
        categoria: ["dermatologia"],
        area: "Dermatología",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Este posgrado de dermatología estética y terapéutica permitirá que al finalizar el mismo, cada médico tenga las herramientas teóricas y la práctica para desenvolverse en esta actividad y así obtener los más altos rendimientos en cada tratamiento que realice.",
        descripcionExtra: [],
        descripcionPreview: "Herramientas teóricas y práctica para desenvolverse en dermatología estética y terapéutica con los más altos rendimientos. Doble titulación FISP y...",
        sobreTitulo: "Formación integral en dermatología estética y terapéutica",
        objetivos: ["Capacitar a los cursantes a realizar un correcto diagnóstico. Adquirir conocimientos necesarios y actualizados para el tratamiento de la patología diagnosticada, junto a la práctica necesaria para realizar procedimientos.", "Concientizar al cursante que cada paciente es único, y que el tratamiento a realizar debe ser personalizado.", "Aportar los conceptos legales necesarios para adentrarse en el campo de la dermatología estética y terapéutica."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Trabajos prácticos", "Prácticas finales (16 y 17 de julio 2027)", "Examen final"],
        destinatarioTags: ["Médicos", "Graduados en Medicina UBA", "Graduados en Medicina de universidades argentinas", "Graduados en Medicina de universidades extranjeras"],
        director: ["Dra. Sylvia B. Pingitore"],
        directorDetalle: ["Directora del Posgrado · (MN 50620) · Dermatóloga · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Sylvia B. Pingitore", detalle: "Directora del Posgrado · (MN 50620) · Dermatóloga · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Diego Slipak (Co-Director)" },
            { titulo: "Dr.", nombre: "Eduardo Pittaro" },
            { titulo: "Dra.", nombre: "Aldana Lallo" },
            { titulo: "Dra.", nombre: "Agustina Maneiro" },
            { titulo: "Dr.", nombre: "Alfredo Ruiz Diaz" }
        ],
        directorImg: [pingitore],
        inicio: "26/08/2026",
        fin: "14/07/2027",
        "practica final": "16/07/2027 y 17/07/2027",
        diasHorarios: "Miércoles 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 340,
        duracion: 10,
        unidades: 9,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Medicina.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de medicina."
        ],
        modalidad: "Virtual",
        temario: 19,
        precioMP: 3600000,
        precioSuscripcionMP: 300000,
        precioTransferencia: 2880000,
        precioPayPal: 2600,
        precioSuscripcionPayPal: 220,
        precioTransferenciaUSA: 2080,
        cuotas: 12,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=575250952600447f908ff7b08d4662eb",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/B3HE00gDZucG2fzpvh2b6fvEPThqNHRV",
        cuposLlenos: false,
    },
    {
        id: 215,
        codigoT: "400.24",
        nombre: "Posgrado en Nutrición Clínica",
        foto: nutriClinica,
        url: "posgrado-nutricion-clinica",
        tipo: "Posgrado",
        categoria: ["nutricion"],
        area: "Nutrición",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La nutrición tiene un papel fundamental en el estado de salud de las personas. Es necesario que los profesionales alcancen un dominio elevado en esta área, manteniendo de forma permanente una puesta al día, que permita evaluar un tratamiento terapéutico adecuado para cada individuo.",
        descripcionExtra: ["Contamos con un programa completo mediante el cual, cada profesional, recibirá todo el conocimiento actualizado y necesario sobre la nutrición clínica, pudiendo abordar cada paciente de una forma integral y personalizada."],
        descripcionPreview: "Formación integral y actualizada en nutrición clínica para el abordaje personalizado de cada paciente. Doble titulación FISP y Facultad de...",
        sobreTitulo: "La nutrición como pilar fundamental del estado de salud",
        objetivos: ["Brindar al profesional los conocimientos científicos actualizados sobre la nutrición.", "Establecer un programa de tratamiento que incluya a todo el equipo de salud abordando cambios en el estilo de vida, educación terapéutica, estrategias de adherencia, acompañamiento terapéutico y familiar.", "Aportar a los profesionales herramientas nuevas para favorecer la adherencia sobre los cambios necesarios en el estilo de vida del paciente."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividad en foro", "Entrega de trabajos prácticos", "Examen final"],
        destinatarioTags: ["Lic. en Nutrición", "Médicos de Familia", "Clínicos", "Generalistas", "Endocrinología", "Psiquiatría", "Cardiología", "Graduados UBA y otras universidades"],
        director: ["Dra. Elena Pastor Manfredi"],
        directorDetalle: ["Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dra. Elena Pastor Manfredi", detalle: "Directora del Posgrado · (MN 163753) · Especialista en Nutrición · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dr.", nombre: "Raúl F. Pastor (Co-Director)" },
            { titulo: "Lic.", nombre: "Laura Iermoli" },
            { titulo: "Dra.", nombre: "Isabel Pastor" },
            { titulo: "Dra.", nombre: "M. Eugenia Leone" },
            { titulo: "Dr.", nombre: "Mario Groberman" },
            { titulo: "Dra.", nombre: "M. Florencia Correa" },
            { titulo: "Dra.", nombre: "Grabriela Comesaña" },
            { titulo: "Dr.", nombre: "Anibal Manfredi" }
        ],
        directorImg: [manfredi],
        inicio: "27/08/2026",
        fin: "15/07/2027",
        diasHorarios: "Jueves 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 340,
        duracion: 10,
        unidades: 12,
        destinatarios: "Dirigido a Licenciadas/os en Nutrición y otros profesionales de la salud que requieran conocimiento sobre nutrición para la práctica profesional.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a una profesión relacionada a la salud.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a una profesión relacionada a la salud"
        ],
        modalidad: "Virtual",
        temario: 24,
        precioMP: 3000000,
        precioSuscripcionMP: 250000,
        precioTransferencia: 2400000,
        precioPayPal: 2100,
        precioSuscripcionPayPal: 175,
        precioTransferenciaUSA: 1680,
        cuotas: 12,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=94458c4e03ae40bfb3e2b79eaefa25fd",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/p4QK3JbKSiIeDNVzx9cwTkJlAkj1f3Tz",
        cuposLlenos: false,
    },
    {
        id: 208,
        codigoT: "400.23",
        nombre: "Posgrado en Toxicología",
        foto: toxicologia,
        url: "posgrado-toxicologia",
        tipo: "Posgrado",
        categoria: ["criminalistica", "salud-mental-y-adicciones", "emergencias"],
        area: "Toxicología",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La toxicología es una disciplina fundamental en la intersección entre las ciencias médicas, químicas y ambientales. Su conocimiento resulta imprescindible para el abordaje clínico de pacientes expuestos a sustancias tóxicas, la evaluación de riesgos sanitarios, el diseño de políticas públicas y la intervención frente a eventos químicos de interés sanitario o criminalístico.",
        descripcionExtra: ["Este posgrado ofrece una formación integral y actualizada que abarca desde los fundamentos de la toxicología general hasta los aspectos clínicos, ambientales, ocupacionales y sociales del fenómeno tóxico, con especial énfasis en la prevención, diagnóstico, tratamiento y gestión de intoxicaciones agudas y crónicas."],
        descripcionPreview: "Formación integral y actualizada en toxicología médica, ambiental, ocupacional y forense. Doble titulación FISP y Facultad de Medicina de la...",
        sobreTitulo: "Una disciplina fundamental en la intersección de las ciencias médicas, químicas y ambientales",
        objetivos: ["Brindar conocimientos actualizados en toxicología médica, ambiental, ocupacional y forense.", "Capacitar en el abordaje integral del paciente expuesto a tóxicos, desde la evaluación inicial hasta el tratamiento y seguimiento.", "Profundizar en el análisis de sustancias de abuso, drogas sintéticas, precursores químicos y estrategias de prevención.", "Desarrollar habilidades para la evaluación toxicológica en contextos clínicos, periciales y de políticas públicas.", "Promover el análisis crítico de la evidencia científica y el trabajo interdisciplinario en toxicología."],
        sistemaEvaluacion: ["Dos exámenes parciales", "Actividades en foro", "Entrega de trabajos prácticos", "Trabajo integrador", "Participación en clases sincrónicas", "Examen final"],
        destinatarioTags: ["Médicos", "Profesionales de la salud con carrera de grado", "Graduados UBA", "Graduados universidades argentinas", "Graduados universidades extranjeras"],
        director: ["Dr. Francisco Dadic"],
        directorDetalle: ["Director del Posgrado · (M.N. 125795) · Médico Toxicólogo · Fundación Iberoamericana de Salud Pública"],
        direccionAcademica: [
            { nombre: "Dr. Francisco Dadic", detalle: "Director del Posgrado · (M.N. 125795) · Médico Toxicólogo · Fundación Iberoamericana de Salud Pública" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Dra.", nombre: "Banny Zelada (Bolivia)" },
            { titulo: "Dr.", nombre: "Jesús Boadas (República Dominicana)" },
            { titulo: "Mg.", nombre: "Ignacio Cichello" },
            { titulo: "Dr.", nombre: "Calle Mourin (Ecuador)" },
            { titulo: "Mg.", nombre: "Roberto Moro" },
            { titulo: "Lic.", nombre: "Facundo Prieto" },
            { titulo: "Lic.", nombre: "Natalia Giogia" },
            { titulo: "Dr.", nombre: "Diego Slipak" },
            { titulo: "Dr.", nombre: "Favio Orellana" },
            { titulo: "Dra.", nombre: "Giselle de Cou (Paraguay)" }
        ],
        directorImg: [dadic],
        inicio: "24/08/2026",
        fin: "12/07/2027",
        diasHorarios: "Lunes 18 a 20 hs",
        quincenal: false,
        clases: 38,
        horas: 340,
        duracion: 10,
        unidades: 15,
        destinatarios: "Dirigido a Médicos y profesionales de la salud (obtendrán titulación FISP + Facultad de Medicina UBA) y profesionales de otras carreras con título de grado (obtendrán titulación FISP).",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Medicina",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Medicina"
        ],
        modalidad: "Virtual",
        temario: 23,
        precioMP: 2600000,
        precioSuscripcionMP: 220000,
        precioTransferencia: 2080000,
        precioPayPal: 1800,
        precioSuscripcionPayPal: 150,
        precioTransferenciaUSA: 1440,
        cuotas: 12,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=ba21a36661854b9faa837c60b1ccf0bc",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/NyEuTrhweI2Es0IZSbdGkjE2QRHXc7SG",
        cuposLlenos: false,
    },
    {
        id: 122,
        codigoT: "400.9",
        nombre: "Diplomatura en Enfermería Oncológica",
        foto: oncologica,
        url: "diplomatura-enfermeria-oncologica",
        tipo: "Diplomatura",
        categoria: ["enfermeria"],
        area: "Enfermería Oncológica",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "Formarte en enfermería oncológica es asumir el compromiso de brindar cuidados especializados en cada etapa del tratamiento. Esta diplomatura te prepara para intervenir con rigor científico, acompañar a los pacientes con sensibilidad y trabajar en equipos interdisciplinarios.",
        descripcionExtra: [],
        descripcionPreview: "Te brindaremos lo necesario para que continúes especializándote y adquiriendo herramientas científicas que te ayudarán a implementar ...",
        sobreTitulo: "",
        objetivos: [],
        sistemaEvaluacion: [],
        destinatarioTags: ["Licenciados en Enfermería", "Enfermeros profesionales"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Mag.", nombre: "María Constanza Celano" },
            { titulo: "Lic.", nombre: "Paola Arellano" },
            { titulo: "Lic.", nombre: "Sandra Ibarra" },
            { titulo: "Lic.", nombre: "Silvana Chero" },
        ],
        directorImg: [devicentiis],
        inicio: "27/08/2026",
        fin: "17/12/2026",
        diasHorarios: "Jueves 20 a 22 hs",
        quincenal: false,
        clases: null,
        horas: 175,
        duracion: 5,
        unidades: null,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Licenciatura en Enfermería.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Licenciatura en Enfermería"
        ],
        modalidad: "Virtual",
        temario: 11,
        precioMP: 720000,
        precioSuscripcionMP: 120000,
        precioTransferencia: 576000,
        precioPayPal: 540,
        precioSuscripcionPayPal: 90,
        precioTransferenciaUSA: 432,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=a29ddb48c0d14d06a94050854ee74e5f",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/knfEKYB6O9XxyQRVJjGS0qsChQs5v1gG",
        cuposLlenos: false,
    },
    {
        id: 123,
        codigoT: "400.10",
        nombre: "Diplomatura en Enfermería de Consumos Problemáticos",
        foto: consumos,
        url: "diplomatura-enfermeria-consumos-problematicos",
        tipo: "Diplomatura",
        categoria: ["enfermeria", "salud-mental-y-adicciones"],
        area: "Consumos Problemáticos",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La enfermería cumple un rol clave en la detección temprana, el abordaje y la recuperación de personas con consumo problemático de sustancias. Esta diplomatura te brinda herramientas actualizadas para intervenir con eficacia, sensibilidad y visión interdisciplinaria.",
        descripcionExtra: [],
        descripcionPreview: "El rol de la enfermería en la atención integral de pacientes con consumo problemático de sustancias es fundamental. Como profesionales..",
        sobreTitulo: "",
        objetivos: [],
        sistemaEvaluacion: [],
        destinatarioTags: ["Licenciados en Enfermería", "Enfermeros profesionales"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Lic.", nombre: "Francisco Dadic" },
            { titulo: "Lic.", nombre: "Juliana Lanza" },
        ],
        directorImg: [devicentiis],
        inicio: "06/08/2026",
        fin: "03/12/2026",
        diasHorarios: "Jueves 18 a 20 hs",
        quincenal: false,
        clases: null,
        horas: 170,
        duracion: 5,
        unidades: null,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "a) Ser graduado de universidades argentinas con título de grado correspondiente a la carrera de Enfermería.",
            "b) Ser graduado de universidades extranjeras con título de grado correspondiente a la carrera de Enfermería"
        ],
        modalidad: "Virtual",
        temario: 13,
        precioMP: 810000,
        precioSuscripcionMP: 135000,
        precioTransferencia: 648000,
        precioPayPal: 600,
        precioSuscripcionPayPal: 100,
        precioTransferenciaUSA: 480,
        cuotas: 6,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=e7f57ab3c2964b73bdc5f59efced6e08",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/xUjzb8zH8KNxIFsslIyQxcHyg3BHDprg",
        cuposLlenos: true,
    },
    {
        id: 205,
        codigoT: "400.20",
        nombre: "Posgrado de Gestión y Administración en Enfermería",
        foto: gestionEnfermeria,
        url: "posgrado-gestion-administracion-enfermeria",
        tipo: "Posgrado",
        categoria: ["enfermeria"],
        area: "Administración de Enfermería",
        titulacion: "Título FISP y Facultad de Medicina de la UBA",
        certificaciones: [
            { certificacion: "FISP + UBA", aplicaA: "Según destinatarios y requisitos del programa." }
        ],
        descripcion: "La gestión y administración efectiva de los servicios de enfermería se ha convertido en un factor clave para asegurar la calidad y eficiencia de la atención sanitaria. La evidencia científica respalda la importancia de contar con profesionales de enfermería con habilidades en gestión, liderazgo y toma de decisiones informadas para enfrentar los retos actuales y futuros en el ámbito de la salud.",
        descripcionExtra: [],
        descripcionPreview: "La gestión y administración efectiva de los servicios de enfermería se ha convertido en un factor clave para asegurar la calidad y eficiencia..",
        sobreTitulo: "",
        objetivos: [],
        sistemaEvaluacion: [],
        destinatarioTags: ["Licenciados en Enfermería"],
        director: ["Lic. Esp. Leonardo De Vincentiis"],
        directorDetalle: ["(MN 72146) · Licenciado en Enfermería"],
        direccionAcademica: [
            { nombre: "Lic. Esp. Leonardo De Vincentiis", detalle: "(MN 72146) · Licenciado en Enfermería" }
        ],
        codireccion: [],
        codireccionDetalle: [],
        codireccionAcademica: [],
        equipoDocente: [
            { titulo: "Mag.", nombre: "Ana María Mosca" },
            { titulo: "Mag.", nombre: "Cinthia De Armas" },
            { titulo: "Mag.", nombre: "Matías Isólica" },
            { titulo: "Mag.", nombre: "Nicolás Matiz" },
            { titulo: "Mag.", nombre: "Raúl Ureta" },
            { titulo: "Lic. Esp.", nombre: "Andrea Leyton" },
            { titulo: "Lic. Esp.", nombre: "Romina D´Arano" },
            { titulo: "Lic.", nombre: "Jaqueline Perez Pizarro" },
            { titulo: "Lic.", nombre: "Emma Abalos" },
            { titulo: "Lic. Esp.", nombre: "María José Aybar" },
        ],
        directorImg: [devicentiis],
        inicio: "28/08/2026",
        fin: "16/07/2027",
        diasHorarios: "Viernes 20 a 22 hs",
        quincenal: false,
        clases: 38,
        horas: 330,
        duracion: 10,
        unidades: null,
        destinatarios: "Dirigido a Licenciados en Enfermería y Enfermeros profesionales.",
        requisitos: [
            "Graduado con título de grado correspondiente a la Licenciatura en Enfermería"
        ],
        modalidad: "Virtual",
        temario: 24,
        precioMP: 1620000,
        precioSuscripcionMP: 135000,
        precioTransferencia: 1296000,
        precioPayPal: 1200,
        precioSuscripcionPayPal: 100,
        precioTransferenciaUSA: 960,
        cuotas: 12,
        linkSuscripcionMP: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=3981bf4b01e14f2084345e4b9834b5e1",
        linkSuscripcionDlocal: "https://checkout.dlocalgo.com/validate/subscription/i71jbEZAfN41UH5ZuoejbndIxbUCsBbk",
        cuposLlenos: false,
    }
];

const courseThemePresets = {
    nutricion: {
        primary: "#1f6a51",
        primaryDark: "#0e4d38",
        primaryLight: "#8bbcae",
        pale: "#dfeee8",
        background: "#f7fbf8",
        navy: "#164638",
        navyDark: "#091f18",
        heroStart: "#091f18",
        heroMid: "#1f6a51",
        heroEnd: "#164638",
    },
    toxicoAdicciones: {
        primary: "#9c221d",
        primaryDark: "#620604",
        primaryLight: "#d88b86",
        pale: "#f7e1df",
        background: "#fff8f7",
        navy: "#5d1715",
        navyDark: "#220505",
        heroStart: "#220505",
        heroMid: "#9c221d",
        heroEnd: "#5d1715",
    },
    neurocardio: {
        primary: "#7a5a40",
        primaryDark: "#261c12",
        primaryLight: "#cdb195",
        pale: "#f2e7dc",
        background: "#fcf8f4",
        navy: "#574230",
        navyDark: "#1e140d",
        heroStart: "#1e140d",
        heroMid: "#7a5a40",
        heroEnd: "#574230",
    },
    enfermeria: {
        primary: "#5a82ad",
        primaryDark: "#375d85",
        primaryLight: "#aac0d8",
        pale: "#e4edf5",
        background: "#f8fbff",
        navy: "#294a6e",
        navyDark: "#101d2c",
        heroStart: "#101d2c",
        heroMid: "#5a82ad",
        heroEnd: "#294a6e",
    },
    gineco: {
        primary: "#8f4a63",
        primaryDark: "#5b2638",
        primaryLight: "#d5a3b5",
        pale: "#f7e5ec",
        background: "#fef9fb",
        navy: "#6a3247",
        navyDark: "#261019",
        heroStart: "#261019",
        heroMid: "#8f4a63",
        heroEnd: "#6a3247",
    },
    marketing: {
        primary: "#892c4f",
        primaryDark: "#4c081e",
        primaryLight: "#d394aa",
        pale: "#f7e3ea",
        background: "#fff9fb",
        navy: "#642138",
        navyDark: "#24040d",
        heroStart: "#24040d",
        heroMid: "#892c4f",
        heroEnd: "#642138",
    },
    criminalistica: {
        primary: "#4c5564",
        primaryDark: "#1c1f26",
        primaryLight: "#a6afbd",
        pale: "#e6eaef",
        background: "#fafbfd",
        navy: "#323844",
        navyDark: "#0f1115",
        heroStart: "#0f1115",
        heroMid: "#4c5564",
        heroEnd: "#323844",
    },
    tecnologia: {
        primary: "#31507a",
        primaryDark: "#131b2d",
        primaryLight: "#9aadd0",
        pale: "#e1e8f3",
        background: "#f7f9fc",
        navy: "#253752",
        navyDark: "#0b1120",
        heroStart: "#0b1120",
        heroMid: "#31507a",
        heroEnd: "#253752",
    },
    medicinaLaboral: {
        primary: "#1d6460",
        primaryDark: "#053635",
        primaryLight: "#93bbb8",
        pale: "#dff0ef",
        background: "#f7fbfb",
        navy: "#0f4947",
        navyDark: "#031c1b",
        heroStart: "#031c1b",
        heroMid: "#1d6460",
        heroEnd: "#0f4947",
    },
    dermatologia: {
        primary: "#4264b7",
        primaryDark: "#192e6b",
        primaryLight: "#a3b6ea",
        pale: "#e5ebfb",
        background: "#f7f9ff",
        navy: "#243d82",
        navyDark: "#0c1636",
        heroStart: "#0c1636",
        heroMid: "#4264b7",
        heroEnd: "#243d82",
    },
    rcpUrgencias: {
        primary: "#c34036",
        primaryDark: "#931717",
        primaryLight: "#ef9b94",
        pale: "#fbe3e1",
        background: "#fff8f7",
        navy: "#7a211e",
        navyDark: "#2c0707",
        heroStart: "#2c0707",
        heroMid: "#c34036",
        heroEnd: "#7a211e",
    },
    skincare: {
        primary: "#af8d57",
        primaryDark: "#856735",
        primaryLight: "#dcc8a5",
        pale: "#f5ede2",
        background: "#fdfaf7",
        navy: "#6b542d",
        navyDark: "#2c2111",
        heroStart: "#2c2111",
        heroMid: "#af8d57",
        heroEnd: "#6b542d",
    },
    paiAcompanante: {
        primary: "#2484b8",
        primaryDark: "#065b88",
        primaryLight: "#8dcee9",
        pale: "#e1f2f9",
        background: "#f7fcfe",
        navy: "#0a4e72",
        navyDark: "#041e2c",
        heroStart: "#041e2c",
        heroMid: "#2484b8",
        heroEnd: "#0a4e72",
    },
    slate: {
        primary: "#4c5564",
        primaryDark: "#1c1f26",
        primaryLight: "#a6afbd",
        pale: "#e6eaef",
        background: "#fafbfd",
        navy: "#323844",
        navyDark: "#0f1115",
        heroStart: "#0f1115",
        heroMid: "#4c5564",
        heroEnd: "#323844",
    },
};

const courseRouteOverrides = {
    "curso-acomp-terapeutico-adicciones": {
        routeFamily: "cursos",
        routeSlug: "acompanante-terapeutico-adicciones",
        routeAliases: [
            {
                family: "cursos",
                slug: "acomp-terapeutico-adicciones",
            }
        ],
    },
    "diplomatura-skincare": {
        routeFamily: "cursos",
        routeSlug: "especialista-skincare",
        routeAliases: [
            {
                family: "cursos",
                slug: "skincare",
            }
        ],
    },
    "diplomatura-nutricion-plant-based": {
        routeFamily: "cursos",
        routeSlug: "nutricion-plant-based",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-plant-based",
            }
        ],
    },
    "programa-inmunizaciones": {
        routeFamily: "cursos",
        routeSlug: "programa-ampliado-inmunizaciones",
        routeAliases: [
            {
                family: "cursos",
                slug: "programa-inmunizaciones",
            }
        ],
    },
    "curso-rcp": {
        routeFamily: "cursos",
        routeSlug: "reanimacion-cardiopulmonar",
        routeAliases: [
            {
                family: "cursos",
                slug: "rcp",
            }
        ],
    },
    "diplomatura-innovacion-digital": {
        routeFamily: "diplomaturas",
        routeSlug: "innovacion-digital-salud",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "innovacion-digital",
            }
        ],
    },
    "diplomatura-nutricion-deportiva": {
        routeFamily: "diplomaturas",
        routeSlug: "nutricion-deportiva-alto-rendimiento",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-deportiva",
            }
        ],
    },
    "diplomatura-nutricion-diabetes": {
        routeFamily: "diplomaturas",
        routeSlug: "nutricion-diabetes-tipo2",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "nutricion-diabetes",
            }
        ],
    },
    "diplomatura-criminalistica-ciencias-forenses": {
        routeFamily: "diplomaturas",
        routeSlug: "criminalistica-ciencias-forenses",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "criminalistica-forenses",
            }
        ],
    },
    "diplomatura-ginecologia-regenerativa-estetica-funcional": {
        routeFamily: "diplomaturas",
        routeSlug: "ginecologia-regenerativa-estetica-funcional",
        routeAliases: [
            {
                family: "diplomaturas",
                slug: "ginecologia-regenerativa",
            }
        ],
    },
};

const courseThemeOverrides = {
    "curso-acomp-terapeutico-adicciones": "paiAcompanante",
    "diplomatura-skincare": "skincare",
    "diplomatura-nutricion-plant-based": "nutricion",
    "curso-operador-prehospitalario-emergencias": "rcpUrgencias",
    "programa-inmunizaciones": "paiAcompanante",
    "curso-rcp": "rcpUrgencias",
    "diplomatura-innovacion-digital": "tecnologia",
    "diplomatura-medicina-adicciones": "toxicoAdicciones",
    "diplomatura-nutricion-deportiva": "nutricion",
    "diplomatura-nutricion-diabetes": "nutricion",
    "diplomatura-nutricion-microbiota": "nutricion",
    "diplomatura-urgencias-neurocardiologicas": "neurocardio",
    "diplomatura-bioremodelacion-facial": "dermatologia",
    "diplomatura-microtrasplante-capilar": "dermatologia",
    "diplomatura-criminalistica-ciencias-forenses": "criminalistica",
    "diplomatura-ginecologia-regenerativa-estetica-funcional": "gineco",
    "diplomatura-ia-medica": "tecnologia",
    "diplomatura-medicina-laboral-energia-mineria": "medicinaLaboral",
    "diplomatura-marketing-medico": "marketing",
    "posgrado-bigdata-ia-salud": "tecnologia",
    "posgrado-dermatologia-estetica-terapeutica": "dermatologia",
    "posgrado-nutricion-clinica": "nutricion",
    "posgrado-toxicologia": "toxicoAdicciones",
    "posgrado-gestion-administracion-enfermeria": "enfermeria",
    "diplomatura-enfermeria-oncologica": "enfermeria",
    "diplomatura-enfermeria-consumos-problematicos": "enfermeria",
};

const defaultRouteFamilyByType = {
    Curso: "cursos",
    Diplomatura: "diplomaturas",
    Posgrado: "posgrados",
};

const stripRoutePrefix = (value) =>
    value
        .replace(/^(posgrado|diplomatura|curso)-/, "")
        .replace(/^programa-/, "programa-");

const resolveCourseTheme = (curso) => {
    const themeKey = courseThemeOverrides[curso.url] || "slate";
    const theme = courseThemePresets[themeKey] || courseThemePresets.slate;

    return {
        key: themeKey,
        ...theme,
    };
};

cursos.forEach((curso) => {
    const routeOverride = courseRouteOverrides[curso.url] || {};
    const routeFamily =
        routeOverride.routeFamily || defaultRouteFamilyByType[curso.tipo] || "cursos";
    const routeSlug = routeOverride.routeSlug || stripRoutePrefix(curso.url);
    const routeAliases = [...(routeOverride.routeAliases || [])];

    if (curso.url !== routeSlug) {
        routeAliases.push({ family: routeFamily, slug: curso.url });
    }

    Object.assign(curso, {
        "practica final": curso["practica final"] ?? null,
        descuentos: curso.descuentos ?? true,
        routeFamily,
        routeSlug,
        routeAliases,
        theme: resolveCourseTheme(curso),
        hasMediaAssets: false,
    });
});

export { cursos };
